import produce from 'immer'
import { SET_CREATE_CLIENT_FROM, SET_ACTIVE_TAB } from '../actions/actionTypes'

export const initialState = {
  activeTab: null,
  createClientFrom: undefined,
}

export default (state = initialState, { type, data, tabName }) =>
  produce(state, draft => {
    switch (type) {
      case SET_CREATE_CLIENT_FROM:
        draft.createClientFrom = data.from
        break

      case SET_ACTIVE_TAB:
        draft.activeTab = tabName
        break

      default:
        break
    }
  })
